(function () {
  var drawer = document.getElementById('rs-cart-drawer');
  var overlay = document.getElementById('rs-cart-overlay');
  if (!drawer || !overlay) return;

  var money = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '';

  function open() { overlay.classList.add('is-open'); drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  window.RSCart = { open: open, close: close, refresh: refresh, addVariant: addVariant };

  // Open triggers: any [data-rs-cart-open] or the nav cart link
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-rs-cart-open]');
    if (openBtn) { e.preventDefault(); open(); }
    var closeBtn = e.target.closest('[data-rs-cart-close]');
    if (closeBtn) { e.preventDefault(); close(); }
    var atc = e.target.closest('[data-rs-atc]');
    if (atc) { e.preventDefault(); handleAtc(atc); }
  });

  // ATC click → /cart/add.js
  function handleAtc(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var sellingPlanId = btn.getAttribute('data-selling-plan-id');
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    if (!variantId) {
      // Try to find variant id from a nearby selected pack option; if none, look document-wide.
      var scope = btn.closest('section, .rs-energy-pdp-buy, .rs-protein-pdp-buy, .rs-mixed-buy, .rs-merch-pdp-buy') || document;
      var selectedPack = scope.querySelector('.pdp__pack[aria-current="true"], .pdp__pack-option[aria-current="true"]')
        || document.querySelector('.pdp__pack[aria-current="true"], .pdp__pack-option[aria-current="true"]')
        || document.querySelector('[data-rs-atc][data-variant-id]:not([data-variant-id=""])');
      if (selectedPack) variantId = selectedPack.getAttribute('data-variant-id');
    }
    if (!variantId) {
      alert('This product is temporarily unavailable. Please try again in a moment.');
      console.warn('[RSCart] ATC button missing data-variant-id', btn);
      return;
    }
    // Flash button feedback
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    addVariant(variantId, qty, sellingPlanId).finally(function () {
      btn.textContent = original;
      btn.disabled = false;
    });
  }

  function addVariant(variantId, quantity, sellingPlanId) {
    var body = { items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] };
    if (sellingPlanId) body.items[0].selling_plan = parseInt(sellingPlanId, 10);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) { console.error('[RSCart] add failed', err); });
  }

  function refresh() {
    return fetch('/?section_id=rs-cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newDrawer = tmp.querySelector('#rs-cart-drawer');
        if (newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
        }
        // Update nav count if present
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-rs-cart-count]').forEach(function (el) {
              el.textContent = '(' + cart.item_count + ')';
            });
          });
      });
  }

  // Line-item mutations (delegated)
  drawer.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = line.querySelector('[data-cart-qty]');
    var current = parseInt(qtyEl.textContent, 10) || 0;

    if (e.target.closest('[data-cart-qty-inc]')) { changeLine(key, current + 1); }
    else if (e.target.closest('[data-cart-qty-dec]')) { changeLine(key, Math.max(0, current - 1)); }
    else if (e.target.closest('[data-cart-remove]')) { changeLine(key, 0); }
  });

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refresh(); })
      .catch(function (err) { console.error('[RSCart] change failed', err); });
  }

  // Escape closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
